export default "__VITE_ASSET__CSad0aGV__"